import React from 'react';

const LoadingDots = () => {
    return (
        <div className="flex gap-3 animate-fade-in-up">
            {/* Bot Avatar */}
            <div className="flex-shrink-0 w-8 h-8 rounded-full bg-black flex items-center justify-center">
                <svg className="w-4 h-4 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.75 17L9 20l-1 1h8l-1-1-.75-3M3 13h18M5 17h14a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                </svg>
            </div>

            {/* Typing Indicator */}
            <div className="bg-white rounded-2xl rounded-tl-md px-4 py-3 shadow-sm border border-gray-200">
                <div className="flex gap-1 items-center h-5">
                    <div className="w-2 h-2 bg-gray-400 rounded-full loading-dot"></div>
                    <div className="w-2 h-2 bg-gray-400 rounded-full loading-dot"></div>
                    <div className="w-2 h-2 bg-gray-400 rounded-full loading-dot"></div>
                </div>
            </div>
        </div>
    );
};

export default LoadingDots;
